import {
  Button,
  Flex,
  Heading,
  IconAddLine,
  IconInfoSolid,
  Text,
  Tooltip,
  View,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import MapRatingsToMasteryModal from "./MapRatingsToMasteryModal";
import RatingScale from "./RatingScale";

const RatingScales = ({ loading, mappedRatingScales, setUpdateMappings }) => {
  const { t } = useTranslation();
  return (
    <Flex
      justifyItems="space-between"
      alignItems="center"
      wrap="wrap"
      gap="small"
      margin="small 0 0 0"
    >
      <Flex.Item>
        <Heading level="h3">
          {t("masteryLevels.assessmentScales")}{" "}
          <Tooltip
            on={["hover", "focus"]}
            placement="top"
            renderTip={
              <div style={{ width: 800 }}>
                {t("masteryLevels.assessmentScalesInfo")}
              </div>
            }
          >
            <IconInfoSolid size="x-small" color="brand" />
          </Tooltip>
        </Heading>
      </Flex.Item>
      <Flex.Item>
        <CreateCustomScaleButton setUpdateMappings={setUpdateMappings} />
      </Flex.Item>
      <Flex.Item>
        <div
          style={{
            textAlign: "left",
            border: "1px solid #89CFF0",
            padding: 10,
            borderRadius: "5px",
          }}
        >
          <View as="p" margin="0 0 small 0">
            <Text size="small" fontStyle="italic" weight="bold">
              {t("masteryLevels.institutionalDefaultDefHeader")}
            </Text>
            <Text size="small">
              {t("masteryLevels.institutionalDefaultDef")}
            </Text>
          </View>
          <View as="p">
            <Text size="small" fontStyle="italic" weight="bold">
              {t("masteryLevels.canvasDefaultDefHeader")}
            </Text>
            <Text size="small">{t("masteryLevels.canvasDefaultDef")}</Text>
          </View>
        </div>
      </Flex.Item>
      {loading ? (
        <Flex.Item size="100%">
          <Skeleton
            count={2}
            style={{ height: 64, borderRadius: 5, marginBottom: 15 }}
          />
        </Flex.Item>
      ) : (
        mappedRatingScales.map((mapping, key) => (
          <Flex.Item key={key} size="100%">
            <RatingScale
              ratingScale={mapping}
              setUpdateMappings={setUpdateMappings}
            />
          </Flex.Item>
        ))
      )}
    </Flex>
  );
};

export default RatingScales;

const CreateCustomScaleButton = ({ setUpdateMappings }) => {
  const { t } = useTranslation();
  const [openMappingModal, setOpenMappingModal] = useState(false);

  return (
    <>
      <Button
        id="map-ratings-button"
        margin="small 0 0 0"
        color="primary"
        onClick={() => setOpenMappingModal(true)}
        renderIcon={IconAddLine}
      >
        {t("masteryLevels.createMappings")}
      </Button>
      <MapRatingsToMasteryModal
        open={openMappingModal}
        setOpen={setOpenMappingModal}
        handleClose={() => setOpenMappingModal(false)}
        updateMappings={setUpdateMappings}
      />
    </>
  );
};
